import React from 'react';

export const Cover = ({ children, backgroundImage, className = '', id = '' }) => {
  return (
    <div id={id} className={`image-cover ${className}`} style={{ backgroundImage }}>
      {children}
    </div>
  );
};
